export var ACTIONS;
(function (ACTIONS) {
    ACTIONS["Read"] = "r";
    ACTIONS["Write"] = "r,c,u,d";
    ACTIONS["Create"] = "r,c";
    ACTIONS["Update"] = "r,u";
    ACTIONS["Delete"] = "r,d";
})(ACTIONS || (ACTIONS = {}));
//# sourceMappingURL=types.js.map